<template>
    <v-layout row wrap class="pl-3 pr-2">
        <confirmation-header-text
            :text="'Permanent address of '"
            class="ml-2"
            icon="mdi-map-marker-radius"/>
        <v-flex sm3 xs6>
            <list-item-detail
                :sub_title="application_data.full_address"
                title="Full address"/>
        </v-flex>
        <v-flex xs12>
            <v-divider class="my-3"/>
        </v-flex>
        <V-flex xs12>
            <confirmation-header-text
                text="Reason for the visa"
                class="ml-2"
                icon="question_answer"/>
        </V-flex>
        <v-flex xs12>
            <v-banner single-line v-if="application_data.reputation_field" class="custom-banner">
                I have a good reputation in {{application_data.reputation_field}}
            </v-banner>
            <v-banner single-line v-if="application_data.contribution_field" class="custom-banner">
                I would like to contribute in the {{application_data.contribution_field}} Field of Nepal.
            </v-banner>
            <v-banner single-line v-if="application_data.invested_million_dollar" class="custom-banner">
                I have invested at least one million USD in Nepal.
            </v-banner>
            <v-banner single-line v-if="application_data.other_reason" class="custom-banner">
                Others: {{application_data.other_reason}}
            </v-banner>
        </v-flex>
    </v-layout>
</template>
<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            }
        },
        components: {
            ListItemDetail, ConfirmationHeaderText
        }
    };
</script>

<style>
</style>
